import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import bookThr from '@/components/bookThr'
import yueIndex from '@/components/activity/yuexiu/index'
import yueAppointment from '@/components/activity/yuexiu/Appointment'
import yueBookSuccess from '@/components/activity/yuexiu/BookSuccess'
import yueAddressList from '@/components/activity/yuexiu/AddressList'
import yueAddressEdit from '@/components/activity/yuexiu/AddressEdit'
import yueOouyanMini from '@/components/activity/yuexiu/oouyanMini'
import yuePartner from '@/components/activity/yuexiu/partner'
import yueBox from '@/components/activity/yuexiu/box'
import yueOrderList from '@/components/activity/yuexiu/OrderList'
import yueOrderDetail from '@/components/activity/yuexiu/OrderDetail'
import yuePartnerDetail from '@/components/activity/yuexiu/yuePartnerDetail'
import birdindex from '@/components/activity/bird/index'
import BirdAppointment from '@/components/activity/bird/Appointment'
import BirdInsertNum from '@/components/activity/bird/Insertnum'
import BirdAddressList from '@/components/activity/bird/AddressList'
import BirdAddressEdit from '@/components/activity/bird/AddressEdit'
import BirdBookSuccess from '@/components/activity/bird/BookSuccess'
import JustWeAli from '@/components/JustWeAli'
import HaveNotOpen from '@/components/HaveNotOpen'
import Appointment from '@/components/Appointment'
import usercenter from '@/components/usercenter/Index'
import intro from '@/components/usercenter/Intro'
import ConcatUs from '@/components/usercenter/ConcatUs'
import ApiList from '@/components/usercenter/ApiList'
import ApiEdit from '@/components/usercenter/ApiEdit'
import beanCash from '@/components/usercenter/beanCash'
import appointmentSuccessH5 from '@/components/usercenter/appointmentSuccessH5'
import appointmentSuccessH5Community from '@/components/usercenter/appointmentSuccessH5Community'
import MobileValid from '@/components/usercenter/MobileValid'
import OrderList from '@/components/usercenter/OrderList'
import OrderDetail from '@/components/usercenter/OrderDetail'
import AddressList from '@/components/usercenter/AddressList'
import AddressEdit from '@/components/usercenter/AddressEdit'
import Profile from '@/components/usercenter/Profile'
import CertificateList from '@/components/usercenter/CertificateList'
import Certificate from '@/components/usercenter/Certificate'
import PointRecord from '@/components/usercenter/PointRecord'
import Activity from '@/components/activity/List'
import ActivityDetail from '@/components/activity/Detail'
import ActivityAppointment from '@/components/activity/Appointment'
import yuexiuActivityAppointment from '@/components/activity/yuexiu/activityappointment'
import Buy from '@/components/activity/Buy'
import orderHistoryInfo from '@/components/orderHistoryInfo/List'

import Main from '@/components/Main'
import Article_1 from '@/components/article/article_1.vue'
import Article_2 from '@/components/article/article_2.vue'
import Article_3 from '@/components/article/article_3.vue'
import Article from '@/components/article/article.vue'
import ArticleCommunity from '@/components/article/articleCommunity.vue'

import Love from '@/components/love/List'
import LoveDetail from '@/components/love/Detail'
import Story from '@/components/story/List'
import StoryDetail from '@/components/story/Detail'


import MobileAuth from '@/components/MobileAuth'
import ScanResult from '@/components/ScanResult'
import LoginSuccess from '@/components/LoginSuccess'
import failure from '@/components/Failure'
import success from '@/components/Success'
import LuckyActivity from '@/components/LuckyActivity'


import support from '@/components/support/Index'
import TerminalList from '@/components/support/TerminalList'
import TerminalControl from '@/components/support/TerminalControl'
import SupportOrderList from '@/components/support/OrderList'
import OrderScan from '@/components/support/OrderScan'
import Install from '@/components/support/Install'
import SignList from '@/components/support/SignList'
import WorkOrderList from '@/components/support/WorkOrderList'
import WorkOrderDetail from '@/components/support/WorkOrderDetail'
import MessageList from '@/components/support/MessageList'
import ExchangeBean from '@/components/exchangeBean'
import PartnerQrCode from '@/components/partnerQrCode'
import PartnerRoute from '@/components/support/PartnerRoute'

import EnvEducationDetail from '@/components/envEducation/Detail'
import EnvEducationList from '@/components/envEducation/List'

import AppointmentSuccess from '@/components/AppointmentSuccess'
import LinkCustomerService from '@/components/LinkCustomerService'
import Follow from '@/components/follow'

import map from '@/components/manager/Map'


import Roster from '@/components/chat/roster'
import Chat from '@/components/chat/chat'

//小程序发现金红包时需要公众号授权，跳转该页面授权
import Auth from '@/components/auth'

//城市服务预约界面
import UrbanServiceAppointment from '@/components/urbanService/appointment'
import UrbanServiceAddressEdit from '@/components/urbanService/AddressEdit'
import UrbanServiceAddressList from '@/components/urbanService/AddressList'
import UrbanServiceOrderList from '@/components/urbanService/OrderList'
import UrbanServiceOrderDetail from '@/components/urbanService/OrderDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/urbanService/appointment',
      name: 'UrbanServiceAppointment',
      component: UrbanServiceAppointment,
      meta: {
        title: '预约回收',
        keepAlive: true
      } 
    },
    {
      path: '/urbanService/addressEdit',
      name: 'UrbanServiceAddressEdit',
      component: UrbanServiceAddressEdit,
      meta: {
        title: '地址编辑',
        keepAlive: true
      } 
    },
    {
      path: '/urbanService/addressList',
      name: 'UrbanServiceAddressList',
      component: UrbanServiceAddressList,
      meta: {
        title: '地址列表',
        keepAlive: false
      } 
    },
    {
      path: '/urbanService/orderList',
      name: 'UrbanServiceOrderList',
      component: UrbanServiceOrderList,
      meta: {
        title: '订单列表',
        keepAlive: false
      } 
    },
    {
      path: '/urbanService/orderDetail',
      name: 'UrbanServiceOrderDetail',
      component: UrbanServiceOrderDetail,
      meta: {
        title: '订单详情',
        keepAlive: false
      } 
    },
    {
      path: '/HaveNotOpen',
      name: 'HaveNotOpen',
      component: HaveNotOpen,
      meta: {
        title: '尚未开放',
        keepAlive: true
      }
    },
    {
      path: '/JustWeAli',
      name: 'JustWeAli',
      component: JustWeAli,
      meta: {
        title: '请在微信支付宝打开',
        keepAlive: true
      }
    },
    {
      path: '/BirdBookSuccess',
      name: 'BirdBookSuccess',
      component: BirdBookSuccess,
      meta: {
        title: '预约成功',
        keepAlive: true
      }
    },
    {
      path: '/yueBookSuccess',
      name: 'yueBookSuccess',
      component: yueBookSuccess,
      meta: {
        title: '预约成功',
        keepAlive: true
      }
    },
    {
      path: '/BirdAddressList',
      name: 'BirdAddressList',
      component: BirdAddressList,
      meta: {
        title: '常用地址',
        keepAlive: true
      }
    },
    {
      path: '/yueAddressList',
      name: 'yueAddressList',
      component: yueAddressList,
      meta: {
        title: '常用地址',
        keepAlive: true
      }
    },
    {
      path: '/BirdAddressEdit',
      name: 'BirdAddressEdit',
      component: BirdAddressEdit,
      meta: {
        title: '编辑地址',
        keepAlive: true
      }
    },
    {
      path: '/yueAddressEdit',
      name: 'yueAddressEdit',
      component: yueAddressEdit,
      meta: {
        title: '编辑地址',
        keepAlive: true
      }
    },
    {
      path: '/yueOouyanMini',
      name: 'yueOouyanMini',
      component: yueOouyanMini,
      meta: {
        title: '鸥燕小程序二维码',
        keepAlive: true
      }
    },
    {
      path: '/yuePartner',
      name: 'yuePartner',
      component: yuePartner,
      meta: {
        title: '附近网点',
        keepAlive: false
      }
    },
    {
      path: '/BirdInsertNum',
      name: 'BirdInsertNum',
      component: BirdInsertNum,
      meta: {
        title: '菜鸟驿站回收页面',
        keepAlive: true
      }
    },
    {
      path: '/BirdAppointment',
      name: 'BirdAppointment',
      component: BirdAppointment,
      meta: {
        title: '菜鸟驿站回收页面',
        keepAlive: true
      }
    },
    {
      path: '/birdindex',
      name: 'birdindex',
      component: birdindex,
      meta: {
        title: '菜鸟驿站回收主页',
        keepAlive: true
      }
    },

    {
      path: '/yueIndex',
      name: 'yueIndex',
      component: yueIndex,
      meta: {
        title: '越秀回收项目主页',
        keepAlive: true
      }
    },
    {
      path: '/yueAppointment',
      name: 'yueAppointment',
      component: yueAppointment,
      meta: {
        title: '越秀回收页面',
        keepAlive: true
      }
    },

    {
      path: '/yueBox',
      name: 'yueBox',
      component: yueBox,
      meta: {
        title: '附近箱子',
        keepAlive: false
      }
    },

    {
      path: '/bookthr',
      name: 'bookThr',
      component: bookThr,
      meta: {
        title: '闲置衣物回收',
        keepAlive: true
      }
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      meta: {
        title: '鸥燕闲置衣物回收',
        keepAlive: true
      }
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '闲置衣服回收',
        keepAlive: true
      }
    },
    {
      path: '/appointment',
      name: 'Appointment',
      component: Appointment,
      meta: {
        title: '预约回收',
        keepAlive: true
      }
    },
    {
      path: '/appointmentSuccess',
      name: 'appointmentSuccess',
      component: AppointmentSuccess,
      meta: {
        title: '成功',
        keepAlive: true
      }
    },
    {
      path: '/usercenter',
      component: usercenter,
      meta: {
        title: '个人中心',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/intro',
      component: intro,
      meta: {
        title: '关于我们',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/concatUs',
      component: ConcatUs,
      meta: {
        title: '联系我们',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/apilist',
      component: ApiList,
      meta: {
        title: 'API管理',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/apiedit',
      component: ApiEdit,
      meta: {
        title: 'API设置',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/mobileValid',
      component: MobileValid,
      meta: {
        title: '手机验证',
        keepAlive: false
      }
    },
    {
      path: '/yueOrderList',
      component: yueOrderList,
      meta: {
        title: '我的订单',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/orderList',
      component: OrderList,
      meta: {
        title: '我的订单',
        keepAlive: false
      }
    },
    {
      path: '/yueOrderDetail',
      component: yueOrderDetail,
      meta: {
        title: '溯源信息',
        keepAlive: false
      }
    },
    {
      path: '/yuePartnerDetail',
      component: yuePartnerDetail,
      meta: {
        title: '回收点信息',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/orderDetail',
      component: OrderDetail,
      meta: {
        title: '溯源信息',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/addressList',
      component: AddressList,
      meta: {
        title: '常用地址',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/addressEdit',
      component: AddressEdit,
      meta: {
        title: '编辑地址',
        keepAlive: false
      }
    },
    {
      path: '/activity',
      component: Activity,
      meta: {
        title: '回收活动',
        keepAlive: true
      }
    },
    {
      path: '/activity/detail',
      component: ActivityDetail,
      meta: {
        title: '活动详情',
        keepAlive: false
      }
    },
    {
      path: '/activity/appointment',
      component: ActivityAppointment,
      meta: {
        title: '现场预约',
        keepAlive: false
      }
    },
    {
      path: '/activity/yuexiu/activityappointment',
      component: yuexiuActivityAppointment,
      meta: {
        title: '网点回收',
        keepAlive: false
      }
    },
    {
      path: '/activity/buy',
      component: Buy,
      meta: {
        title: '购买',
        keepAlive: false
      }
    },
    {
      path: '/orderHistoryInfo',
      component: orderHistoryInfo,
      meta: {
        title: '溯源查询',
        keepAlive: true
      }
    }
    ,
    {
      path: '/mobileAuth',
      component: MobileAuth,
      meta: {
        title: '手机认证',
        keepAlive: false
      }
    }
    ,
    {
      path: '/scanResult',
      component: ScanResult,
      meta: {
        title: '扫码收衣',
        keepAlive: false
      }
    },
    {
      path: '/loginSuccess',
      component: LoginSuccess,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/failure',
      component: failure,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/success',
      component: success,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/love',
      component: Love,
      meta: {
        title: '爱心专题',
        keepAlive: false
      }
    },
    {
      path: '/love/detail',
      component: LoveDetail,
      meta: {
        title: '详情',
        keepAlive: false
      }
    },
    {
      path: '/story',
      component: Story,
      meta: {
        title: '故事专题',
        keepAlive: false
      }
    },
    {
      path: '/story/detail',
      component: StoryDetail,
      meta: {
        title: '详情',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/profile',
      component: Profile,
      meta: {
        title: '个人信息',
        keepAlive: true
      }
    },
    {
      path: '/manager/map',
      component: map,
      meta: {
        title: '回收箱地图分布',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/pointRecord',
      component: PointRecord,
      meta: {
        title: '积分记录',
        keepAlive: false
      }
    },
    {
      path: '/support',
      component: support,
      meta: {
        title: '运营支持中心',
        keepAlive: false
      }
    }, {
      path: '/support/terminalList',
      component: TerminalList,
      meta: {
        title: '箱体跟踪',
        keepAlive: false
      }
    }, {
      path: '/support/terminalControl',
      component: TerminalControl,
      meta: {
        title: '箱体控制',
        keepAlive: false
      }
    }, {
      path: '/support/orderList',
      component: SupportOrderList,
      meta: {
        title: '回收箱收衣',
        keepAlive: false
      }
    }, {
      path: '/support/orderScan',
      component: OrderScan,
      meta: {
        title: '收衣',
        keepAlive: false
      }
    }, {
      path: '/support/install',
      component: Install,
      meta: {
        title: '回收箱安装',
        keepAlive: false
      }
    }, {
      path: '/support/signList',
      component: SignList,
      meta: {
        title: '签到记录',
        keepAlive: false
      }
    }, {
      path: '/support/workOrderList',
      component: WorkOrderList,
      meta: {
        title: '我的任务',
        keepAlive: false
      }
    }, {
      path: '/support/workOrderDetail',
      component: WorkOrderDetail,
      meta: {
        title: '任务详情',
        keepAlive: false
      }
    }, {
      path: '/support/messageList',
      component: MessageList,
      meta: {
        title: '消息中心',
        keepAlive: false
      }
    }, {
      path: '/support/PartnerRoute',
      component: PartnerRoute,
      meta: {
        title: '合伙人导航',
        keepAlive: false
      }
    },
    {
      path: '/usercenter/beanCash',
      component: beanCash,
      meta: {
        title: '鸥豆提现',
        keepAlive: false
      }
    }, {
      path: '/usercenter/appointmentSuccessH5',
      component: appointmentSuccessH5,
      meta: {
        title: '',
        keepAlive: false
      }
    }, {
      path: '/usercenter/appointmentSuccessH5Community',
      component: appointmentSuccessH5Community,
      meta: {
        title: '',
        keepAlive: false
      }
    }, {
      path: '/exchangeBean',
      component: ExchangeBean,
      meta: {
        title: '付豆',
        keepAlive: false
      }
    }, {
      path: '/partnerQrCode',
      component: PartnerQrCode,
      meta: {
        title: '选择操作方式',
        keepAlive: false
      }
    },
    {
      path: '/article/article_1',
      component: Article_1,
      meta: {
        title: '预约回收的常见问题',
        keepAlive: false
      }
    },
    {
      path: '/article/article_2',
      component: Article_2,
      meta: {
        title: '如何参与闲置衣物回收？',
        keepAlive: false
      }
    },
    {
      path: '/article/article_3',
      component: Article_3,
      meta: {
        title: '开通城市',
        keepAlive: false
      }
    },
    {
      path: '/article/article',
      component: Article,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/envEducation/Detail',
      component: EnvEducationDetail,
      meta: {
        title: '环境教育详情',
        keepAlive: false
      }
    },
    {
      path: '/luckyActivity',
      component: LuckyActivity,
      meta: {
        title: '幸运抽奖',
        keepAlive: false
      }
    },
    {
      path: '/envEducation/List',
      component: EnvEducationList,
      meta: {
        title: '环境教育',
        keepAlive: true
      }
    },
    {
      path: '/linkCustomerService',
      component: LinkCustomerService,
      meta: {
        title: '联系客服',
        keepAlive: true
      }
    },
    {
      path: '/follow',
      component: Follow,
      meta: {
        title: '预约回收',
        keepAlive: true
      }
    },
    {
      path: '/usercenter/certificateList',
      component: CertificateList,
      meta: {
        title: '我的证书',
        keepAlive: true
      }
    },
    {
      path: '/usercenter/certificate',
      component: Certificate,
      meta: {
        title: '环保证书',
        keepAlive: true
      }
    },
    {
      path: '/commnity/article',
      component: ArticleCommunity,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/chat/roster',
      component: Roster,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/chat/chat',
      component: Chat,
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/auth',
      component: Auth,
      meta: {
        title: '',
        keepAlive: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js